import { render, staticRenderFns } from "./Cats.vue?vue&type=template&id=96ddf8cc&"
import script from "./Cats.vue?vue&type=script&lang=js&"
export * from "./Cats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports